import { render, staticRenderFns } from "./navision-file.vue?vue&type=template&id=064eedcf&"
import script from "./navision-file.vue?vue&type=script&lang=js&"
export * from "./navision-file.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports